module.exports = __webpack_public_path__ + "static/media/holousvideo.82291a9c.jpeg";